import React, { Component } from "react";

import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import { Input, Box, Typography } from '@mui/material';

class DBHeader extends Component {
  state = {
    isModalVisible: false,
    editTitle: "",
    editSubtitle: "",
  };

  showModal = () => {
    const mainTitle = "3 Trends That Favor";
    const subTitle = "Sellers";
    this.setState({
      isModalVisible: true,
      editTitle: mainTitle,
      editSubtitle: subTitle,
    });
  };

  handleOk = () => {
    // Here you would typically save the changes to your backend
    this.setState({ isModalVisible: false });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };
  modalButton = () => {
    return (
      <Button
        variant="contained"
        color="primary"
        onClick={this.showModal}
        style={{
          position: "absolute",
          bottom: "-230px",
          left: "-50%",
          transform: "translateX(-50%)",
          fontSize: "12px",
        }}
      >
        Edit Title/Subtitle
      </Button>
    );
  };
  render() {
    const { mlsAreaID } = this.props.currentArea;
    const { sentences, agentData } = this.props;
    const { listgenUserID } = agentData;
    let advantagesLength = sentences
      .map((sentence) => sentence.benefit)
      .filter((adv) => adv === "Seller's").length;
    let dbHeaderSubStyles = "";
    if (
      listgenUserID === "109973" ||
      listgenUserID === "109938" ||
      listgenUserID === "112336"
    ) {
      dbHeaderSubStyles = "bolded-sub-title";
    }
    const headerContent = () => {
      if (advantagesLength == "3") {
        if (mlsAreaID === "CCA-4400P") {
          return (
            <>
              <div className="db-header-main">3 Trends That Favor</div>
              <div className={`db-header-sub ${dbHeaderSubStyles}`}>
                Sellers in The Bridges
              </div>
            </>
          );
        } else {
          return (
            <>
              <div className="db-header-main">3 Trends That Favor</div>
              <div className={`db-header-sub ${dbHeaderSubStyles}`}>
                Sellers
              </div>
            </>
          );
        }
      } else if (mlsAreaID === "SMA-303B") {
        return (
          <>
            <div className="db-header-main">3 Relevant Trends</div>
          </>
        );
      } else if (mlsAreaID === "SBA-35J") {
        return (
          <>
            <div className="db-header-main">3 Current Trends</div>
          </>
        );
      } else {
        return (
          <>
            <div className="db-header-main">3 Trends to Watch</div>
            <div className={`db-header-sub ${dbHeaderSubStyles}`}>
              in Today's Market
            </div>
          </>
        );
      }
    };

    const modalStyle = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      backgroundColor: "white",
      boxShadow:
        "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
      padding: 16,
      borderRadius: 4,
    };

    return (
      <div style={{ position: "relative" }}>
        <div className="db-header">{headerContent()}</div>

        <Modal
          open={this.state.isModalVisible}
          onClose={this.handleCancel}
          aria-labelledby="modal-title"
        >
          <Box style={modalStyle}>
            <Typography
              id="modal-title"
              variant="h6"
              component="h2"
              style={{ marginBottom: 12 }}
            >
              Edit Header Text
            </Typography>

            <Box style={{ marginBottom: 8 }}>
              <Typography variant="subtitle1" style={{ marginBottom: 4 }}>
                Title:
              </Typography>
              <Input
                fullWidth
                value={this.state.editTitle}
                onChange={(e) => this.setState({ editTitle: e.target.value })}
              />
            </Box>

            <Box style={{ marginBottom: 12 }}>
              <Typography variant="subtitle1" style={{ marginBottom: 4 }}>
                Subtitle:
              </Typography>
              <Input
                fullWidth
                value={this.state.editSubtitle}
                onChange={(e) =>
                  this.setState({ editSubtitle: e.target.value })
                }
              />
            </Box>

            <Box style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button variant="outlined" onClick={this.handleCancel}>
                Cancel
              </Button>
              <Button variant="contained" onClick={this.handleOk}>
                Save
              </Button>
            </Box>
          </Box>
        </Modal>
      </div>
    );
  }
}

export default DBHeader;
